/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerLangViewModel } from "../types/BannerLangViewModel.ts";

export const bannerLangViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do idioma do banner.")),
  bannerId: z.optional(
    z.number().int().describe("ID do banner ao qual este idioma pertence."),
  ),
  cultureInfo: z
    .string()
    .describe("Código da cultura (RFC 4646). Ex: pt-BR, en-US.")
    .nullish(),
  cultureDisplayName: z
    .string()
    .describe("Nome do idioma por extenso.")
    .nullish(),
  url: z
    .string()
    .describe("URL de destino ao clicar no banner neste idioma. Opcional.")
    .nullish(),
  filePath: z
    .string()
    .describe("URL pública da imagem ou vídeo principal neste idioma.")
    .nullish(),
  filePathMobile: z
    .string()
    .describe("URL pública da imagem ou vídeo mobile neste idioma.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se este idioma está ativo.")),
}) as unknown as ToZod<BannerLangViewModel>;
